import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#07542F] text-white py-12 px-4 border-t border-white/10">
      <div className="container">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <div className="inline-flex items-center justify-center h-20 w-20 bg-white rounded-full p-[5px]">
                <img src="/NutreTe2.png" alt="Logo de Nútrete" width="80" height="80" loading="lazy" decoding="async" className="h-full w-full object-contain" />
              </div>
            </div>
            <p className="text-white/70 body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
              Bienestar corporativo con una mirada distinta: nutrición,
              fitoterapia y educación práctica para tus equipos.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-lg">Enlaces rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="#sello" className="text-white/70 hover:text-white transition-colors body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                  Nuestro sello
                </a>
              </li>
              <li>
                <a href="#lineas" className="text-white/70 hover:text-white transition-colors body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                  Líneas de negocio
                </a>
              </li>
              <li>
                <a href="#natacha" className="text-white/70 hover:text-white transition-colors body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                  Sobre Natacha
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-white/70 hover:text-white transition-colors body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4 text-lg">Información de contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#009444]" />
                <a href="mailto:contacto@nutrete.cl" className="body-small hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.7)' }}>contacto@nutrete.cl</a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#009444]" />
                <a href="https://wa.me/56965667828" target="_blank" rel="noopener noreferrer" className="body-small hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.7)' }}>+56 9 6566 7828</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#009444]" />
                <span className="body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>Santiago, Chile</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="body-small" style={{ color: 'rgba(255,255,255,0.7)' }}>
            © {currentYear} Nútrete. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
